export default __webpack_public_path__ + "static/media/label.vert.9102e993.glsl";